import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleSicurezza from "@/pages/article-sicurezza/page";
import ArticlePrincipianti from "@/pages/article-principianti/page";
import ArticleStrategie from "@/pages/article-strategie/page";
import ArticleErrori from "@/pages/article-errori/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guida-itaobuy-sheet-2026",
    element: <ArticlePage />,
  },
  {
    path: "/guida-sicurezza-itaobuy",
    element: <ArticleSicurezza />,
  },
  {
    path: "/come-usare-itaobuy-principianti",
    element: <ArticlePrincipianti />,
  },
  {
    path: "/strategie-ricerca-prodotti",
    element: <ArticleStrategie />,
  },
  {
    path: "/errori-comuni-itaobuy",
    element: <ArticleErrori />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;